import { Box } from '#/components/Box/Box';
import type { FormUsageContext } from '#/components/Form/Form';
import { Form } from '#/components/Form/Form';
import type { FormSubmitFunction } from '#/components/Form/FormContext';
import { GeneralError } from '#/components/Form/GeneralError';
import { InputField } from '#/components/Form/InputField';
import { SubmitButton } from '#/components/Form/SubmitButton/SubmitButton';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';

export type ForgotPasswordFormValues = {
  email: string;
};

type Props = {
  analyticsTitle: string;
  usageContext: FormUsageContext;
  initialValues: ForgotPasswordFormValues;
  emailSent: boolean;
  submitForgotPassword: FormSubmitFunction<ForgotPasswordFormValues>;
};

export function ForgotPasswordForm({
  analyticsTitle,
  usageContext,
  initialValues,
  emailSent,
  submitForgotPassword,
}: Props) {
  const { i18n } = useI18n();

  return (
    <Form
      analyticsTitle={analyticsTitle}
      usageContext={usageContext}
      qaId="forgot-password-form"
      initialValues={initialValues}
      onSubmit={submitForgotPassword}
      render={() =>
        emailSent ? (
          <Text mt={3} mb={4}>
            {
              /* TRANSLATORS: user forgot their password */
              i18n(
                "We've sent an email to the address you provided. Please follow the instructions to reset your password. If you do not receive the email, you may have created an account with Facebook or Google instead.",
              )
            }
          </Text>
        ) : (
          <>
            <GeneralError />

            <InputField
              label={i18n('Enter your email')}
              name="email"
              type="email"
              placeholder={i18n('casey.smith@example.com')}
            />

            <Box display="flex" justifyContent="flex-end">
              <SubmitButton size="large">
                {/* TRANSLATORS: when the user forgot their password  */}
                {i18n('Send reset link')}
              </SubmitButton>
            </Box>
          </>
        )
      }
    />
  );
}
